import { IntlProvider } from 'react-intl'
import { RouterProvider } from 'react-router-dom'

import { THEME, ThemeProvider } from '@themenu/design-system'

import { messages } from '../i18n'
import { getLocale } from '../i18n/detect-locale'
import { router } from '../routes/router'

export const Providers = (): JSX.Element => {
  const userLocale = getLocale()
  return (
    <IntlProvider locale={userLocale} messages={messages[userLocale]}>
      <ThemeProvider theme={THEME.DARK}>
        <RouterProvider router={router} />
      </ThemeProvider>
    </IntlProvider>
  )
}
